// extracted by mini-css-extract-plugin
module.exports = {"photo":"propertyFloorPlans_photo__2L0IN","container":"propertyFloorPlans_container__1cxtT","title":"propertyFloorPlans_title__2nKU9"};
    if(module.hot) {
      // 1790670306600
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  